import { TicketsActionType } from './enums';
import { TicketsAction, TicketsState } from './interfaces';

export const initialState: TicketsState = {
	error: null,
	loading: false,
	ticketsList: [],
	totalRecords: 0
};
export default (state = initialState, { type, payload }: TicketsAction): TicketsState => {
	switch (type) {
		case TicketsActionType.FETCH_ALL_TICKETS: {
			return {
				...state,
				loading: true
			};
		}
		case TicketsActionType.STORE_ALL_TICKETS: {
			return {
				...state,
				loading: false,
				ticketsList: payload.ticketsList,
				totalRecords: payload.totalRecords
			};
		}
		case TicketsActionType.ERROR_ALL_TICKETS: {
			return {
				...state,
				loading: false,
				error: payload.error
			};
		}

		default: {
			return {
				...state
			};
		}
	}
};
